'use client'

import * as React from 'react'
import { Button } from '@/components/ui/deprecated-button'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

export function EmployerReviewModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean | null
  onClose: () => void
}): React.JSX.Element {
  return (
    <Dialog open={Boolean(isOpen)} onOpenChange={onClose}>
      <DialogContent
        title="Ready to see all salaries?"
        className="overflow-auto"
      >
        <DialogTitle className="text-2xl">Welcome to Marit!</DialogTitle>
        <p className="text-copy-accent">
          Our team will review your request and notify you via email when your
          account is approved.
        </p>
        <p className="mt-2 mb-4 text-copy-accent">
          With Marit, you’ll have access to salary trends & reports to support
          your compensation strategy. We have bigger aspirations ahead and hope
          to have more to share soon!
        </p>

        <Button className="w-full mt-2" size="lg" onClick={onClose}>
          See All Salaries
        </Button>
      </DialogContent>
    </Dialog>
  )
}
